export default __webpack_public_path__ + "static/media/description-address.9d195d60.png";